// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JQbt","input":"styles_input__3cx0Q"};